export function isZeroWidthRegex(regexStr: string): boolean {
  const zeroWidthRegex = /(\?=|\?!|\?<=|\?<!)/;

  return zeroWidthRegex.test(regexStr);
}
